/**
 * The numbers at the top of a record: a tile per number, its name, its value
 * and a line under it (`tiles`: { label, value, detail }).
 */
const KpiTiles = ({ tiles }) => (
  <div className="grid grid-cols-1 gap-3 tab:grid-cols-3">
    {tiles.map((tile) => (
      <div key={tile.label} className="rounded-xl border border-gray-100 p-4">
        <p className="text-sm font-medium text-gray-900">{tile.label}</p>
        <p className="mt-1 text-2xl font-medium text-gray-900">{tile.value}</p>
        <p className="mt-1 text-xs text-gray-600">{tile.detail}</p>
      </div>
    ))}
  </div>
);

export default KpiTiles;
